import { Pipe, PipeTransform } from '@angular/core';
import { CATALOG } from '@core';

@Pipe({name: 'changeSitePipe'})
export class ChangeSitePipe implements PipeTransform {
  transform(siteCode: string): string {
    // if (CATALOG.getListSite && CATALOG.getListSite.length > 0) {
    //   const item = CATALOG.getListSite.find(f => f.key === siteCode);
    //   if (item && item.value) {
    //     return item.value;
    //   } else {
    //     return siteCode;
    //   }
    // } else {
    //   return siteCode;
    // }
    return ''
  }
}
